import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Sprout, ShieldCheck, Gift, Check, ShoppingBasket, ClipboardCheck } from 'lucide-react';
const blocks = [{
  badge: 'Módulo 1',
  title: 'El Reset',
  subtitle: 'Fase de limpieza profunda',
  description: 'Identificamos y retiramos los irritantes ocultos que provocan tu inflamación abdominal. Calmas el sistema digestivo y desbloqueas tu energía natural desde la primera semana.',
  icon: Sparkles,
  iconBg: 'bg-salvia/20',
  badgeColor: 'bg-forest text-white'
}, {
  badge: 'Módulo 2',
  title: 'Re-población',
  subtitle: 'Microbiota y salud digestiva',
  description: 'Re-introducimos los nutrientes que alimentan tus bacterias buenas. Tu flora intestinal se diversifica y la digestión se vuelve fluida, sin gases ni pesadez.',
  icon: Sprout,
  iconBg: 'bg-olive',
  badgeColor: 'bg-forest text-white'
}, {
  badge: 'Módulo 3',
  title: 'El Estilo de Vida',
  subtitle: 'Mantenimiento para siempre',
  description: 'Consolidamos hábitos y fortalecemos la barrera intestinal. Te llevas un plan claro para mantener tu vientre plano y tu energía sin volver a los síntomas.',
  icon: ShieldCheck,
  iconBg: 'bg-cream-warm',
  badgeColor: 'bg-forest text-white'
}, {
  badge: 'BONUS · GRATIS',
  title: 'Lista de compras + Guía de Seguimiento',
  subtitle: 'Tus dos herramientas prácticas',
  description: 'La Lista de compras Inteligente para saber qué llevar en el carrito cada semana, y la Guía de Seguimiento Diario para medir tu progreso de inflamación abdominal cada mañana.',
  icon: Gift,
  iconBg: 'bg-salvia/30',
  badgeColor: 'bg-[#2D6A4F] text-white',
  isBonus: true
}];
export function ProductStack() {
  return <section className="py-28 md:py-44 bg-cream-warm" data-id="element-216">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-217">
        <div className="text-center mb-16 md:mb-20 max-w-2xl mx-auto" data-id="element-218">
          <span className="inline-flex items-center gap-2 text-salvia font-semibold tracking-[0.25em] text-xs uppercase mb-5" data-id="element-219">
            <Gift className="w-4 h-4" strokeWidth={2.25} data-id="element-220" />
            <span data-id="element-221">Contenido del Bundle</span>
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight text-forest leading-[1.1]" data-id="element-222">
            GUT LABS
            <sup className="text-[0.4em] font-medium ml-0.5 tracking-tight align-super" data-id="element-223">
              TM
            </sup>{' '}
            <span className="italic font-normal text-forest/70" data-id="element-224">
              Complete Bundle
            </span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-forest/70 font-medium" data-id="element-225">
            Llévate todo hoy por solo{' '}
            <span className="font-bold text-[#2D6A4F]" data-id="element-226">$6.36 USD</span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-227">
          {blocks.map((block, i) => {
          const Icon = block.icon;
          return <motion.article key={i} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.5,
            delay: i % 2 * 0.1
          }} className={`bg-white rounded-3xl p-7 md:p-8 border ${block.isBonus ? 'border-[#2D6A4F]/40 ring-2 ring-[#2D6A4F]/15' : 'border-salvia/30'} shadow-sm flex flex-col`} data-id="element-228">
                <div className="flex items-center gap-3 mb-5" data-id="element-229">
                  <span className={`w-14 h-14 rounded-2xl ${block.iconBg} flex items-center justify-center shrink-0`} data-id="element-230">
                    <Icon className="w-7 h-7 text-forest" strokeWidth={1.75} data-id="element-231" />
                  </span>
                  <span className={`inline-flex items-center text-[10px] font-black tracking-[0.18em] uppercase px-2.5 py-1 rounded-full ${block.badgeColor}`} data-id="element-232">
                    {block.badge}
                  </span>
                </div>

                <h3 className="font-serif text-2xl md:text-[1.7rem] font-semibold tracking-tight text-forest leading-[1.15] mb-1" data-id="element-233">
                  {block.title}
                </h3>
                <p className="text-sm font-semibold text-salvia tracking-tight uppercase mb-4" data-id="element-234">
                  {block.subtitle}
                </p>

                <p className="text-[15px] text-forest/75 leading-relaxed" data-id="element-235">
                  {block.description}
                </p>
              </motion.article>;
        })}
        </div>

        {/* Total value recap */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-12 md:mt-14 bg-white border border-salvia/40 rounded-3xl px-6 py-7 md:px-10 md:py-8 text-center" data-id="element-236">
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-salvia mb-3" data-id="element-237">
            Valor real del bundle completo
          </p>
          <div className="flex items-baseline justify-center gap-3 md:gap-4 flex-wrap" data-id="element-238">
            <span className="text-2xl md:text-3xl text-forest/40 font-medium line-through" data-id="element-239">
              $49.00
            </span>
            <span className="text-forest/50 text-lg" data-id="element-240">→</span>
            <span className="font-serif text-5xl md:text-6xl font-bold text-[#2D6A4F] tracking-tight" data-id="element-241">
              $6.36
            </span>
          </div>
          <p className="text-sm md:text-base text-forest/75 font-medium mt-4" data-id="element-242">
            3 Módulos + Lista de compras + Guía de Seguimiento. Todo incluido.
          </p>
        </motion.div>
      </div>
    </section>;
}